import React, { useMemo } from 'react';

import { expValEquals, expVal } from '@confluence/feature-experiments';
import { SuspenseWithDataFetcher } from '@confluence/query-preloader-tools/entry-points/SuspenseWithDataFetcher.ts';
import { HydrationSafeComponent } from '@confluence/hydration-utils/entry-points/HydrationSafeComponent.tsx';

import { getSmartLinksBoundaryNameForUrl } from './smartLinkBatchHelpers.ts';

// Suspense wrapper to be passed to ADF Renderer
function SuspenseWrapperForUrl({ url, children }) {
	if (!url || !expVal('confluence_smartlinks_suspense', 'isEnabled', false)) {
		return children;
	}
	const fetcherName = getSmartLinksBoundaryNameForUrl(url);

	return (
		<SuspenseWithDataFetcher dataFetcherName={fetcherName}>
			<HydrationSafeComponent isEnabled>{children}</HydrationSafeComponent>
		</SuspenseWithDataFetcher>
	);
}

// Put initialState into a getter
export const useStoreOptions = (initialState: any, isPageSSRd: boolean): any =>
	useMemo(() => {
		if (
			initialState &&
			(isPageSSRd || expValEquals('platform_editor_smartlink_local_cache', 'isEnabled', true))
		) {
			return {
				storeOptions: {
					initialState,
				},
				SuspenseWrapperForUrl,
			};
		} else {
			return {
				SuspenseWrapperForUrl,
			};
		}
	}, [initialState, isPageSSRd]);
